import React from 'react';
import FeeType from './FeeType';
import useStyles from './styles';

// export default function FeeStructure({ hidePaperStatement }) {
export default function FeeStructure() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.fees
  }, /*#__PURE__*/React.createElement(FeeType, {
    label: "Late fee",
    enableSwitcher: true
  }), /*#__PURE__*/React.createElement(FeeType, {
    label: "Insufficient funds fee"
  }), /*#__PURE__*/React.createElement(FeeType, {
    label: "Resident account maintenance"
  }), /*#__PURE__*/React.createElement(FeeType, {
    label: "Vacancy cost recovery"
  }));
}